module.exports = __webpack_public_path__ + "static/media/face-party.1f6fadce.svg";